<template>
    <div class="join" v-if="$root.dataReady" v-scroll-spy="{offset: -500}">
        <header class="heading">
            <div class="container">
                <div class="text" v-html="page.content.rendered"></div>
                <StickyNavigation :navigationLinks="blocks"></StickyNavigation>
            </div>
            <div
                class="bg"
                :class="page.acf.hero_picture_position"
                :style="{ 'background-image': 'url( ' + page.better_featured_image.source_url + ' )' }"
            ></div>
        </header>

        <template>
            <template v-for="(block, index) in blocks">
                <component
                    :id="`link-${index}`"
                    :is="block.acf_fc_layout"
                    :key="index"
                    :blockdata="block"
                ></component>
            </template>
        </template>
    </div>
</template>

<script>
import StickyNavigation from "../components/StickyNavigation";
import Block from "../components/Block.vue";
import VideoWrapper from "../components/VideoWrapper";
import BlockDevelopment from "../components/BlockDevelopment.vue";
import BlockJoinUs from "../components/BlockJoinUs.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";
import JoinTeam from "../components/JoinTeam.vue";
import BlockWorkbusterComponent from "../components/BlockWorkbusterComponent";

export default {
    name: "join-us-page",
    data() {
        return {
            blocks: null,
            page: null
        };
    },
    components: {
        StickyNavigation,
        VideoWrapper,
        Block,
        BlockDevelopment,
        BlockJoinUs,
        BlockCmgGreenhouse,
        JoinTeam,
        BlockWorkbusterComponent
    },
    created: function() {
        this.$root.headeriswhite = true;
        this.$root.dataReady = false;
    },
    mounted: function() {
        this.fetchData();
    },
    props: ["slug"],
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
                function(response) {
                    self.blocks = response[0].acf.block_grid;
                    self.page = response[0];
                    self.setTitle(response[0].title.rendered);
                    self.$root.dataReady = true;
                    // console.log("response", response);
                }
            )
                .done(function() {})
                .fail(function() {});
            $.get(self.$root.apiUrl + "wp-json/wp/v2/jobs", function(response) {
                self.posts = response;
                self.$root.dataReady = true;
                // console.log("posts:", response);
            })
                .done(function() {})
                .fail(function() {});
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// Join.vue?750555c9